import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
  Zoom,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { AwardsAndRecognitionsRepository } from "./AwardsAndRecognitionsRepository";
import {
  awardsAndRecognitionValidator,
  awardsAndRecognitionPointsValidator,
} from "./AwardsAndRecognitionValidator";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import GradingCommentComponent from "./GradingCommentComponent";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useState } from "react";

const useStyles = makeStyles(styles);

export default function AwardsAndRecognitionComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [awardRecognitionCarriers, setAwardRecognigitonCarriers] =
    React.useState();
  const [awardTypes, setAwardTypes] = React.useState();
  const [awardLevels, setAwardLevels] = React.useState();
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [rerender, triggerRerender] = React.useState(false);
  const [awardsAndRecognitionData, setAwardsAndRecognitionData] =
    React.useState([]);
  const [
    awardsAndRecognitionDataFormErrors,
    setAwardsAndRecognitionDataFormErrors,
  ] = React.useState({});
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();
  const [awardLevelOptions, setAwardLevelOptions] = useState([]);

  useEffect(() => {
    triggerRerender(!rerender);
  }, [awardsAndRecognitionDataFormErrors]);

  useEffect(() => {
    // AwardsAndRecognitionsRepository.getAllLevels(props.gradingSchemaId).then(
    //   (res) => {
    //     setAwardLevels(res.data);
    //   }
    // );
    AwardsAndRecognitionsRepository.getAllRecognitionCarriers(
      props.gradingSchemaId
    ).then((res) => {
      setAwardRecognigitonCarriers(res.data);
    });
    AwardsAndRecognitionsRepository.getAllTypes(props.gradingSchemaId).then(
      (res) => {
        setAwardTypes(res.data);
      }
    );
    AwardsAndRecognitionsRepository.getAwardsAndRecognitionsData(
      props.vacancyAppId
    ).then(
      async (res) => {
        if (res.data.length > 0) {
          const data = res.data;
          setAwardsAndRecognitionData(data);

          const levelOptions = [];
          const carrierLevelCache = {};
          for (let i = 0; i < data.length; i++) {
            const carrierId = data[i]?.carrier?.id;
            if (carrierId) {
              if (!carrierLevelCache[carrierId]) {
                try {
                  const levelRes =
                    await AwardsAndRecognitionsRepository.getAllLevels(
                      props.gradingSchemaId,
                      carrierId
                    );
                  carrierLevelCache[carrierId] = levelRes.data;
                } catch (e) {
                  carrierLevelCache[carrierId] = [];
                }
              }
              levelOptions[i] = carrierLevelCache[carrierId];
            } else {
              levelOptions[i] = [];
            }
          }
          setAwardLevelOptions(levelOptions);
          triggerRerender((prev) => !prev);
        }
      },
      (err) => {}
    );
  }, []);

  const addRow = () => {
    let data = awardsAndRecognitionData;
    data.push({
      orgName: "",
      awardName: "",
      carrier: { id: "" },
      awardType: { id: "" },
      awardLevel: { id: "" },
      eventType: "",
      year: "",
      proofs: [],
    });
    setAwardsAndRecognitionData(data);
    setAwardsAndRecognitionDataFormErrors({});
    triggerRerender(!rerender);
  };
  const deleteRow = (index) => {
    let data = awardsAndRecognitionData;
    data.splice(index, 1);
    setAwardsAndRecognitionData(data);
    setAwardsAndRecognitionDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = async (event, index, name) => {
    let data = awardsAndRecognitionData;
    if (name === "carrier") {
      const carrierId = event.target.value;
      data[index].carrier.id = carrierId;

      data[index].awardLevel = { id: "" };

      try {
        const res = await AwardsAndRecognitionsRepository.getAllLevels(
          props.gradingSchemaId,
          carrierId
        );
        const updatedLevelOptions = [...awardLevelOptions];
        updatedLevelOptions[index] = res.data;
        setAwardLevelOptions(updatedLevelOptions);
      } catch (err) {
        console.error("Failed to fetch levels", err);
      }
    } else if (name === "awardType" || name === "awardLevel") {
      data[index][name].id = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setAwardsAndRecognitionData(data);
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = awardsAndRecognitionData;
    data[index][name] = date;
    setAwardsAndRecognitionData(data);
    triggerRerender(!rerender);
  };
  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = awardsAndRecognitionData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!awardsAndRecognitionValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await awardsAndRecognitionValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAwardsAndRecognitionDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = awardsAndRecognitionData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!awardsAndRecognitionValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await awardsAndRecognitionValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAwardsAndRecognitionDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    AwardsAndRecognitionsRepository.saveAwardsAndRecognitionsData(
      props.vacancyAppId,
      awardsAndRecognitionData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = awardsAndRecognitionData;
    data[index].proofs = attachments;
    setAwardsAndRecognitionData(data);
  };

  const changePoints = (item) => {
    AwardsAndRecognitionsRepository.updatePoints(item.id, item.points).then(
      (res) => {
        AwardsAndRecognitionsRepository.getAwardsAndRecognitionsData(
          props.vacancyAppId
        ).then(
          (res) => {
            if (res.data.length > 0) {
              setAwardsAndRecognitionData(res.data);
              setAwardsAndRecognitionDataFormErrors({});
              triggerRerender(!rerender);
            }
          },
          (err) => {}
        );
      }
    );
  };

  const unlockPoints = (item) => {
    AwardsAndRecognitionsRepository.unlockPoints(item.id).then((res) => {
      AwardsAndRecognitionsRepository.getAwardsAndRecognitionsData(
        props.vacancyAppId
      ).then(
        (res) => {
          if (res.data.length > 0) {
            setAwardsAndRecognitionData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!awardsAndRecognitionPointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "awards_and_recognitions");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await awardsAndRecognitionPointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setAwardsAndRecognitionDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      AwardsAndRecognitionsRepository.setComment(item.id, item.comment).then(
        (res) => {
          let tmp = awardsAndRecognitionData;
          tmp[index] = item;
          setAwardsAndRecognitionData(tmp);
          triggerRerender(!rerender);
          setShowCommentDialog(false);
        }
      );
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle>{LOCALE.awards_and_recognitions_info_title}</AlertTitle>
          {LOCALE.awards_and_recognitions_info_description}
        </Alert>
      )}
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>
                {LOCALE.list_of_proofs_for_professional_development},{" "}
                {LOCALE.domain} {LOCALE.awards_and_recognitions}
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <Button
                  color="default"
                  variant="contained"
                  className={
                    awardsAndRecognitionData.length == 0 ? "bounceButton" : ""
                  }
                  startIcon={<Icon>add_circle_outline</Icon>}
                  size="small"
                  aria-label="create"
                  style={{ float: "right" }}
                  onClick={addRow}
                >
                  {LOCALE.add_awards_or_recognitions}
                </Button>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.organizer}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.award_name}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.award_carrier}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.awardType}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.award_level}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.eventType}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.year}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {awardsAndRecognitionData.length > 0 ? (
                awardsAndRecognitionData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.orgName}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.orgName}
                          variant="outlined"
                          label={LOCALE.organizer}
                          error={
                            awardsAndRecognitionDataFormErrors[index]?.orgName
                          }
                          helperText={
                            awardsAndRecognitionDataFormErrors[index]?.orgName
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "orgName")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.awardName}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.awardName}
                          variant="outlined"
                          label={LOCALE.award_name}
                          error={
                            awardsAndRecognitionDataFormErrors[index]?.awardName
                          }
                          helperText={
                            awardsAndRecognitionDataFormErrors[index]?.awardName
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "awardName")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.carrier.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index][
                              "carrier.id"
                            ]
                          }
                          size="small"
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.award_carrier}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.award_carrier}
                            value={item.carrier.id}
                            onChange={(e) => handleChange(e, index, "carrier")}
                          >
                            {awardRecognitionCarriers?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {awardsAndRecognitionDataFormErrors[index] &&
                              awardsAndRecognitionDataFormErrors[index][
                                "carrier.id"
                              ]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.awardType.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index][
                              "awardType.id"
                            ]
                          }
                          size="small"
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.awardType}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.awardType}
                            value={item.awardType.id}
                            onChange={(e) =>
                              handleChange(e, index, "awardType")
                            }
                          >
                            {awardTypes?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {awardsAndRecognitionDataFormErrors[index] &&
                              awardsAndRecognitionDataFormErrors[index][
                                "awardType.id"
                              ]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.awardLevel.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled || !item.carrier.id}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index][
                              "awardLevel.id"
                            ]
                          }
                          size="small"
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="award-level-select-label">
                            {LOCALE.award_level}
                          </InputLabel>
                          <Select
                            labelId="award-level-select-label"
                            id={`award-level-select-${index}`}
                            label={LOCALE.award_level}
                            value={item.awardLevel.id}
                            onChange={(e) =>
                              handleChange(e, index, "awardLevel")
                            }
                          >
                            {(awardLevelOptions[index] || []).map(
                              (level, idx) => (
                                <MenuItem value={level.id} key={idx}>
                                  {level.name}
                                </MenuItem>
                              )
                            )}
                          </Select>
                          <FormHelperText>
                            {
                              awardsAndRecognitionDataFormErrors[index]?.[
                                "awardLevel.id"
                              ]?.message
                            }
                          </FormHelperText>
                        </FormControl>
                        {/* <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index][
                              "awardLevel.id"
                            ]
                          }
                          size="small"
                          style={{ width: "150px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.award_level}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.award_level}
                            value={item.awardLevel.id}
                            onChange={(e) =>
                              handleChange(e, index, "awardLevel")
                            }
                          >
                            {awardLevels?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {awardsAndRecognitionDataFormErrors[index] &&
                              awardsAndRecognitionDataFormErrors[index][
                                "awardLevel.id"
                              ]?.message}
                          </FormHelperText>
                        </FormControl> */}
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.eventType}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.eventType}
                          variant="outlined"
                          label={LOCALE.eventType}
                          error={
                            awardsAndRecognitionDataFormErrors[index]?.eventType
                          }
                          helperText={
                            awardsAndRecognitionDataFormErrors[index]?.eventType
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "eventType")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.year}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.year}
                          variant="outlined"
                          label={LOCALE.year}
                          error={
                            awardsAndRecognitionDataFormErrors[index]?.year
                          }
                          helperText={
                            awardsAndRecognitionDataFormErrors[index]?.year
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "year")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          awardsAndRecognitionDataFormErrors[index] &&
                          awardsAndRecognitionDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"AWARDS_AND_RECOGNITIONS"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index]["proofs"]
                              ?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status == "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                style={{ top: "6px" }}
                                size="small"
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            awardsAndRecognitionDataFormErrors[index] &&
                            awardsAndRecognitionDataFormErrors[index][
                              "pointsChecked"
                            ]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "6px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "6px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {awardsAndRecognitionDataFormErrors[index] &&
                              awardsAndRecognitionDataFormErrors[index][
                                "pointsChecked"
                              ]?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_awards_or_recognitions_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            disabled={btnDisabled}
            variant="outlined"
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(awardsAndRecognitionData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status == "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
  );
}
